<section class="relative flex flex-col items-center w-full min-w-0 overflow-x-hidden">
  <div class="relative flex flex-col w-full max-w-5xl gap-6 sm:gap-8 px-2 sm:px-3">
    <div class="relative overflow-hidden rounded-2xl bg-gradient-to-br from-secondary/10 via-white to-secondary/5 border border-gray-200 shadow-card p-4 sm:p-6 md:p-8">
      <div class="absolute -top-12 -right-12 w-40 h-40 rounded-full bg-secondary/10 blur-3xl pointer-events-none"></div>
      <div class="absolute -bottom-10 -left-10 w-32 h-32 rounded-full bg-secondary/10 blur-3xl pointer-events-none"></div>

      <div class="relative flex flex-col gap-4 sm:flex-row sm:items-center sm:gap-5">
        <div class="flex items-center gap-3 sm:gap-5 min-w-0 flex-1">
          <div class="w-14 h-14 sm:w-16 sm:h-16 md:w-20 md:h-20 rounded-2xl bg-gradient-to-br from-secondary to-[#3f77ee] flex items-center justify-center shadow-lg shrink-0">
            <span class="text-xl sm:text-2xl md:text-3xl font-display font-bold text-white">{{ companyInitials() }}</span>
          </div>
          <div class="min-w-0 flex-1">
            <div class="flex items-center gap-2 min-w-0">
              <h1 class="font-display text-lg sm:text-xl md:text-2xl font-bold text-gray-900 truncate">{{ companyDetails().nomEntreprise || 'Mon entreprise' }}</h1>
              <span class="material-symbols-outlined text-secondary text-[18px] shrink-0">auto_awesome</span>
            </div>
            @if (companyDetails().formeJuridique) {
              <span class="inline-block mt-1 text-xs font-medium px-2.5 py-0.5 rounded-full bg-secondary/10 text-secondary">
                {{ companyDetails().formeJuridique }}
              </span>
            }
            @if (companyDetails().domaineActivite) {
              <p class="text-sm text-gray-500 mt-1.5 truncate">{{ companyDetails().domaineActivite }}</p>
            }
          </div>
        </div>

        <button
          type="button"
          (click)="pushWallet()"
          [disabled]="pushing()"
          class="inline-flex w-full sm:w-auto items-center justify-center gap-1.5 rounded-lg border border-gray-300 bg-white px-3 py-2.5 text-sm font-medium text-gray-700 hover:bg-secondary hover:text-white disabled:opacity-60 disabled:cursor-not-allowed cursor-pointer shrink-0"
          title="Envoie les données actuelles aux Apple Wallet"
        >
          <span class="material-symbols-outlined text-[18px]" [class.animate-spin]="pushing()">sync</span>
          {{ pushing() ? 'Envoi...' : 'Pousser au Wallet' }}
        </button>
      </div>
    </div>

    <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
      @for (field of infoFields(); track field.label; let i = $index) {
        <button
          type="button"
          class="group relative rounded-xl border border-gray-200 bg-white p-3.5 sm:p-4 text-left transition-all duration-200 hover:border-secondary/30 hover:shadow-md cursor-pointer min-w-0 w-full"
          (click)="copyField(field.value, i)"
          [title]="field.value !== '—' ? 'Cliquer pour copier' : ''"
        >
          <div class="flex items-start gap-3 min-w-0">
            <div class="w-9 h-9 rounded-lg bg-gray-100 flex items-center justify-center shrink-0 group-hover:bg-secondary/10 transition-colors">
              <span class="material-symbols-outlined text-[17px] text-gray-500 group-hover:text-secondary">{{ field.icon }}</span>
            </div>
            <div class="min-w-0 flex-1 overflow-hidden">
              <div class="text-[11px] uppercase tracking-wider text-gray-500 font-medium">{{ field.label }}</div>
              <div class="text-sm font-semibold text-gray-900 mt-0.5 break-words">{{ field.value }}</div>
            </div>
            @if (field.value !== '—') {
              <div class="opacity-100 sm:opacity-0 sm:group-hover:opacity-100 transition-opacity shrink-0 mt-1">
                <span class="material-symbols-outlined text-[16px]"
                      [class.text-secondary]="copiedFieldIndex() === i"
                      [class.text-gray-500]="copiedFieldIndex() !== i">
                  {{ copiedFieldIndex() === i ? 'done_all' : 'content_copy' }}
                </span>
              </div>
            }
          </div>
        </button>
      }
    </div>
  </div>
</section>
